import React from 'react';
import _ from 'lodash';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import NcDmvDrivewayPermitsModal from './NcDmvDrivewayPermitsModal';
import NcDmvDrivewayPermitsService from '../../../../../service/NcDmvDrivewayPermitsService';

export default class NcDmvDrivewayPermits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      headers: [],
    };

    this.comboFields = [
      {
        value: 'plateNumber',
        display: 'Permit Number',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'transactionId',
        display: 'Transaction Id',
      },
    ];
  }

  getDrivewayPermits(event) {
    const { search, combo, } = event;
    this.reset();

    const vm = this;
    const headers = [];
    const rows = [];
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = 'ncdmv_driveway_permits';

    const allowedKeys = [
      'id',
      'externalAccountId',
      'customerId',
      'paymentAmount',
      'paymentTransactionId',
      'paymentDate',
    ];

    NcDmvDrivewayPermitsService.getDrivewayPermits(criteria)
      .then((response) => {
        const { payables: drivewayPermits, } = response.data;
        if (drivewayPermits.length > 0) {
          allowedKeys.forEach((allowedKey) => {
            headers.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
          drivewayPermits.forEach((permit) => {
            const filtered = _.pick(permit, allowedKeys);
            const date = new Date(filtered.paymentDate);
            filtered.paymentDate = `${date}`;
            rows.push({
              value: Object.values(filtered),
              raw: permit,
            });
          });
        }
        vm.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  onDrivewayPermitSelect(row) {
    const { rows = [], } = this.state;
    const selectedDrivewayPermit = rows.find(order => order.raw.id === row.id);
    this.setState({
      selectedDrivewayPermit: selectedDrivewayPermit.raw,
    });
  }

  formatSelectedRowDisplay = (drivewayPermit) => {
    if (!drivewayPermit) {
      return null;
    }

    return (
      <div>
        <p>{`Selected ID: ${drivewayPermit.id}`}</p>
        <hr />
        <NcDmvDrivewayPermitsModal selectedDrivewayPermit={drivewayPermit} />
      </div>
    );
  };

  reset() {
    this.setState({
      rows: [],
      headers: [],
      selectedDrivewayPermit: null,
    });
  }

  render() {
    const {
      headers = [],
      rows = [],
      selectedDrivewayPermit,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.getDrivewayPermits(data)}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Driveway Permits">
            <Grid
              headers={headers}
              rows={rows}
              style={{ maxHeight: '800px', overflowY: 'auto', }}
              onRowSelect={data => this.onDrivewayPermitSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedDrivewayPermit)}
        </div>
      </div>
    );
  }
}
